import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <div>
      <p>
        React / Material UI Project
        <br />
        <strong>Made be Sergey Vozika</strong>
        <br />
        2022
      </p>
    </div>
  );
};

export default Footer;
